import { render, staticRenderFns } from "./events-list.vue?vue&type=template&id=a97e56f4&"
import script from "./events-list.vue?vue&type=script&lang=js&"
export * from "./events-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports